const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";

export const getImageUrl = (imageUrl) => {
  if (!imageUrl) return "";
  if (/^https?:\/\//i.test(imageUrl)) return imageUrl;
  return `${BACKEND_URL}${imageUrl}`;
};
